<template>
    <page-base>
        <template slot="breadcrumbs">
            <b-breadcrumb :items="breadcrumbs" class="p-0 bg-transparent" />
        </template>
        <template slot="content">
            <b-card footer="Так же, можете связаться со службой поддержки: +7 XXX XX XX XX" footer-tag="footer">
                <p class="card-text">{{ this.$t('staticPages.helpText') }}</p>
                <b-button href="#" variant="primary">{{ this.$t('general.sendLetter') }}</b-button>
            </b-card>
            <hr>
             <b-card>
                <p class="card-text">
                    <a href="https://developer.qiwi.kz/docs/fiscal/sfd-protocol/" target="_blank" >Документация для разработчиков</a>
                </p>
            </b-card>
        </template>
    </page-base>
</template>
<script>
/* eslint-disable */
export default {
    name: 'Help',
    computed: {
        breadcrumbs() {
            var breadcrumbs = []
            if (!this.$store.getters.isLoggedIn) {
                breadcrumbs.push({ text: this.$t('menu.login'), to: { name: 'login' } })
            }
            breadcrumbs.push({ text: this.$t(this.$route.meta.title), active: true })
            return breadcrumbs
        }
    }
}
</script>
